import { ReactNode } from 'react';
import { confirmable, ConfirmDialogProps } from 'react-confirm';

import Button, { ButtonColor, DEFAULT } from '../../Button/Button';
import ButtonContainer from '../../ButtonContainer/ButtonContainer';
import Modal, { CENTER, ModalProps } from '../../Modal/Modal';

import styles from './Confirmation.module.css';

export interface ConfirmationOptions extends Pick<
  ModalProps,
  'title' | 'position' | 'fitWidthByContent' | 'isCloseHidden'
> {
  okLabel?: string;
  cancelLabel?: string;
  okColor?: ButtonColor;
  cancelColor?: ButtonColor;
  showCancelButton?: boolean;
  showOkButton?: boolean;
  wide?: boolean;
}

export type ConfirmationDialogOptions = ConfirmationOptions & { confirmation: ReactNode };

type ConfirmationProps = ConfirmDialogProps<ConfirmationDialogOptions, unknown>;

function Confirmation(props: ConfirmationProps) {
  const {
    okLabel = 'OK',
    okColor = DEFAULT,
    cancelLabel = 'Cancel',
    cancelColor = DEFAULT,
    title,
    confirmation,
    show,
    proceed,
    dismiss,
    cancel,
    showCancelButton = true,
    showOkButton = true,
    wide = false,
    fitWidthByContent = false,
    position = CENTER,
    isCloseHidden = false,
  } = props;

  function onConfirm() {
    proceed(undefined);
  }

  function onCancel() {
    cancel();
  }

  return (
    <Modal
      isShowed={show}
      onClose={dismiss}
      title={title}
      position={position}
      fitWidthByContent={fitWidthByContent}
      isCloseHidden={isCloseHidden}
      headerClassName={styles.confirmationHeader}
      footerClassName={styles.confirmationFooter}
      renderModalFooter={() => (
        <ButtonContainer>
          {showCancelButton && (
            <Button aria-label={cancelLabel} color={cancelColor} onClick={onCancel} wide={wide}>
              {cancelLabel}
            </Button>
          )}

          {showOkButton && (
            <Button aria-label={okLabel} color={okColor} onClick={onConfirm} wide={wide}>
              {okLabel}
            </Button>
          )}
        </ButtonContainer>
      )}
    >
      {confirmation}
    </Modal>
  );
}

export default confirmable<ConfirmationDialogOptions, unknown>(Confirmation);
